
// import React, { useState } from 'react';
// import { Link, useNavigate } from 'react-router-dom';
// import { Menu } from 'lucide-react';
// import './Header.css';
// import { useAuth } from '../context/AuthContext';


// const Header = () => {
//   const navigate = useNavigate();
//   const [menuOpen, setMenuOpen] = useState(false);
//   const { user, logout } = useAuth();

  
//   const toggleMenu = () => {
//     setMenuOpen(!menuOpen);
//   };
  
//   const navigateTo = (path) => {
//     navigate(path);
//     setMenuOpen(false);
//   };

//   const handleLogout = () => {
//     logout();
//     navigate('/');
//     setMenuOpen(false);
//   };
  
//   return (
//     <header className="app-header">
//       <div className="header-container">
//         <Link to="/" className="logo-link">
//           <h2 className="logo">
//             Amenity<span className="logo-accent">Scores</span>
//           </h2>
//         </Link>
        
//         <button className="menu-toggle" onClick={toggleMenu}>
//           <Menu className="menu-icon" size={24} />
//         </button>
        
//         <div className={`auth-buttons ${menuOpen ? 'open' : ''}`}>
//         {user ? (
//             <button
//               className="auth-button signup-button"
//               onClick={handleLogout}
//             >
//               Logout
//             </button>
//           ) : (
//             <>
//           <button 
//             className="auth-button login-button"
//             onClick={() => navigateTo('/login')}
//           >
//             Log In
//           </button>
//           <button 
//             className="auth-button signup-button"
//             onClick={() => navigateTo('/signup')}
//           >
//             Sign Up
//           </button>
//         </>
//         )}
//         </div>
//       </div>
//     </header>
//   );
// };

// export default Header;




import React, { useState, useRef, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Menu } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import './Header.css';

const Header = () => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);

  // 1) create a ref to the menu
  const menuRef = useRef(null);

  const toggleMenu = () => {
    setMenuOpen(open => !open);
  };

  const navigateTo = (path) => {
    navigate(path);
    setMenuOpen(false);
  };

  const handleLogout = () => {
    logout();
    navigate('/');
    setMenuOpen(false);
  };

  // 2) listen for clicks outside the menu, and close it
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        menuOpen &&
        menuRef.current &&
        !menuRef.current.contains(event.target)
      ) {
        setMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [menuOpen]);

  return (
    <header className="app-header">
      <div className="header-container">
        <Link to="/" className="logo-link">
          <h2 className="logo">
            Amenity<span className="logo-accent">Scores</span>
          </h2>
        </Link>

        <button className="menu-toggle" onClick={toggleMenu}>
          <Menu className="menu-icon" size={24} />
        </button>

        {/* 3) attach the ref here */}
        <div
          ref={menuRef}
          className={`auth-buttons ${menuOpen ? 'open' : ''}`}
        >
          {user ? (
            <button
              className="auth-button signup-button"
              onClick={handleLogout}
            >
              Logout
            </button>
          ) : (
            <>
              <button
                className="auth-button login-button"
                onClick={() => navigateTo('/login')}
              >
                Log In
              </button>
              <button
                className="auth-button signup-button"
                onClick={() => navigateTo('/signup')}
              >
                Sign Up
              </button>
            </>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
